<template>
  <div class="container">
    <h4 class="panle-table-title">
      <span v-if="title" style="margin-right:10px;">{{title}}</span>

      <template v-if="title">( </template>

      <span>共 <span style="color: #1890FF">{{total}}</span> 条记录</span>

      <span v-if="selected !== undefined">
        / 已选中 <span style="color: #1890FF">{{selected}}</span> 条
      </span>

      <span v-if="selected"  class="clear-selected-btn" @click="()=>{ $emit('clearAllSelected') }" >
        清除所有选中
      </span>

      <template v-if="title"> )</template>

      <a-icon
        v-if="refresh"
        :style="{'margin-left': '20px', 'color': '#1890ff'}"
        type="sync"
        @click="handlerRefresh"
      />
    </h4>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'TableTips',
  components: {},
  props: {
    title: {
      type: String,
      default: ''
    },
    total: {
      type: Number,
      default: 0
    },
    selected: {
      type: Number,
      default: undefined
    },
    refresh: {
      type: Function,
      default: null
    }
  },
  data () {
    return {}
  },
  methods: {
    handlerRefresh() {
      this.refresh()
    }
  }
}
</script>

<style scoped>
.container {
  width: 100%;
  display:  flex;
  justify-content: flex-start;
  align-items: center;
}
.panle-table-title{
  margin: 0;
  padding: 15px 16px;
  font-size: 16px;
  font-weight: normal;
  /* color: #6c6c6c */
}
/* .panle-table-title:before{
  content: "";
  margin-right: 10px;
  border: 2px solid #1890ff;
  border-radius: 5px;
} */

.clear-selected-btn{
  color: #1890FF;
  margin-left: 20px;
  cursor: pointer;
  font-size: 14px;
}
</style>
